export enum JobFilterField {
  LOCATION = 'location',
  ROLE = 'role',
  TYPE = 'type',
}

export const filterFieldMap = {
  [JobFilterField.LOCATION]: 'offices.name',
  [JobFilterField.ROLE]: 'role',
  [JobFilterField.TYPE]: 'employment_type',
};

/** Delimiter the API will use to signal the search hit within a fragment. */
export const searchTermHitDelimiter = '~~';
